import axiosInstance from '../utils/axiosConfig'
import { mobileBackendUrl } from '../env'
import {
  FundRebalanceData,
  RebalanceQuestionnaireOTPTriggerResponse,
  RebalanceQuestionnaireOTPVerifyPayload,
  RebalanceQuestionnaireOTPVerifyResponse
} from '../types/rebalance'

export const powerRebalanceSummary = () => {
  return axiosInstance.get(`${mobileBackendUrl}/v2/portfolio/power-rebalance/summary`)
}
export const powerRebalanceISIN = (isin: string) => {
  return axiosInstance.get<FundRebalanceData>(`${mobileBackendUrl}/v2/portfolio/power-rebalance/${isin}`)
}

export const saveRiskProfile = (body: any) => {
  return axiosInstance.post(`${mobileBackendUrl}/v2/portfolio/power-rebalance/risk-profile`, body)
}

export const smartRebalance = () => {
  return axiosInstance.get(`${mobileBackendUrl}/v2/portfolio/power-rebalance`)
}

export const triggerRebalanceQuestionnaireOTP = async (): Promise<RebalanceQuestionnaireOTPTriggerResponse> => {
  const payload = {
    postBackParams: {
      familyConsentType: 'REBALANCE_RISK_PROFILE'
    }
  }
  const response = await axiosInstance.post(`${mobileBackendUrl}/v2/family-consent/send-otp`, payload)
  if (!response?.data) {
    throw new Error('Failed to trigger OTP')
  }
  return response?.data as RebalanceQuestionnaireOTPTriggerResponse
}

export const verifyRebalanceQuestionnaireOTP = async (
  payload: RebalanceQuestionnaireOTPVerifyPayload
): Promise<RebalanceQuestionnaireOTPVerifyResponse> => {
  const response = await axiosInstance.post(`${mobileBackendUrl}/v2/family-consent/verify-otp`, payload)
  if (!response?.data) {
    throw new Error('Failed to verify OTP')
  }
  return response?.data as RebalanceQuestionnaireOTPVerifyResponse
}
